import { useContext } from "react"
import { AdminContext } from "context/AdminContext"

export default function UserDirectoryExports() {
    const { UserDirectorySubContext } = useContext(AdminContext)

    return (
        <div className='flex gap-x-4'>
            <button
                type="button"
                className="flex-1 rounded-md bg-white py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={() => UserDirectorySubContext.ExportUserDirectory(UserDirectorySubContext.userDirectoryFilters)}
            >
                Export With Current Filters
            </button>

            <button
                type="button"
                className="flex-1 rounded-md bg-white py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={() => UserDirectorySubContext.ExportNewsletterAthletes()}
            >
                Export Athlete Newsletter List
            </button>

            <button
                type="button"
                className="flex-1 rounded-md bg-white py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={() => UserDirectorySubContext.ExportNewsletterCoaches()}
            >
                Export Coach Newsletter List
            </button>
        </div>
    )
}